import { Component, OnInit, ViewChild } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/custom-validators';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { TutorService } from 'src/app/services/tutor.service';
import { SupporterService } from 'src/app/services/supporter.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { CategoryService } from 'src/app/services/category.service';
import { TagsService } from 'src/app/services/tags.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AnimaltypesService } from 'src/app/services/animaltypes.service';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss']
})
export class CourseComponent implements OnInit {
  public loadedCourse:boolean = false;
  public course: Course;
  private courseId;
  public courseForm: FormGroup;
  public Editor = ClassicEditor;
  public Editor2 = ClassicEditor;
  public supporters=[];
  public tutors=[];
  public categories=[];
  private courseTutors=[];
  private courseSupporters=[];
  public courseCategories=[];
  public courseTags=[];
  public tags=[];
  public userRoles=[]; // 1=vet 2=vet nurse 3=non clinical
  @ViewChild("descriptionEditor", {static: false}) descriptionEditor:any;
  @ViewChild("topicsEditor", {static: false}) topicsEditor:any;
  dropdownSettings:IDropdownSettings;
  dropdownSettings2:IDropdownSettings={
    idField: 'id',
    textField: 'role'
  };
  public animalTypes;
  public roleVet:boolean=false;
  public roleVetNurse:boolean=false;
  public roleNonClinical:boolean=false;
  public roles=[{id:1,role:'Vet'}, {id:2,role:'Vet Nurse'}, {id:3,role:'Non Clinical'}];

  constructor(
    private courseService: CourseService,
    private tutorService: TutorService,
    private supporterService: SupporterService,
    private _notify: MatSnackBar,
    private route: ActivatedRoute,
    private _cat: CategoryService,
    private _tag: TagsService,
    private _animalType: AnimaltypesService
  ) {
    this.courseId = this.route.snapshot.paramMap.get("id");
    this.courseForm = new FormGroup({
      title: new FormControl('',[Validators.required,CustomValidators.validateTextField]),
      description: new FormControl('',[Validators.required,CustomValidators.validateTextField]),
      topics: new FormControl(''),
      points: new FormControl('',[Validators.required]),
      published: new FormControl('',[Validators.required]),
      tutors: new FormControl(''),
      supporters: new FormControl(''),
      categories: new FormControl(''),
      tags: new FormControl(''),
      animaltype: new FormControl(''),
      userRoles: new FormControl(''),
      addTags: new FormControl('')
    });
  }

  public refreshCourseImage(){
    this.courseService.refreshCourseImage(this.course.id).subscribe(
      res=>{
        if (res.message=='success') {
          this.getCourse();
          this.notify('Course image refreshed.', 'OK');
        } else {
          this.notify('Error refreshing course image.', 'OK');
        }
      }
    );
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  public updateCourse(){
    this.course.title=this.courseForm.get('title').value;
    this.course.description=this.courseForm.get('description').value;
    this.course.topics=this.courseForm.get('topics').value;
    this.course.points=this.courseForm.get('points').value;
    this.course.published=this.courseForm.get('published').value;
    this.course.animal_type_id=this.courseForm.get('animaltype').value;
    if (this.course.title==''){
      return this.notify('Course must have a title', 'OK');
    }
    this.courseService.updateCourse(this.course, this.courseForm.get('supporters').value, this.courseForm.get('tutors').value, this.courseForm.get('categories').value, this.courseForm.get('tags').value, this.courseForm.get('userRoles').value).subscribe(
      (res:Course) => {
        return this.notify('Course updated.', 'OK');
      }
    );
  }

  getCourse(){
    this.courseService.getCourse(this.courseId, true).subscribe(course=>{
      this.course=course;
      this.courseForm.get('title').setValue(this.course.title);
      this.courseForm.get('description').setValue(this.course.description);
      this.courseForm.get('topics').setValue(this.course.topics);
      this.courseForm.get('points').setValue(this.course.points);
      this.courseForm.get('published').setValue(this.course.published);
      this.course.tutors.forEach(item => { this.courseTutors.push(item.tutor_id) });
      this.courseForm.get('tutors').setValue(this.courseTutors);
      this.course.supporters.forEach(item => { this.courseSupporters.push(item.supporter_id) });
      this.courseForm.get('supporters').setValue(this.courseSupporters);
      this.course.category.forEach(item => { this.courseCategories.push(item.id) });
      this.courseForm.get('categories').setValue(this.courseCategories);
      this.courseTags=[];
      this.course.tags.forEach(item=>{ this.courseTags.push(item.tag) });
      this.courseForm.get('tags').setValue(this.courseTags);
      this.courseForm.get('animaltype').setValue(this.course.animal_type_id || 0);
      this.userRoles=[];
      this.course.user_roles.forEach(item=>{ this.userRoles.push({id: item.id, role: item.role}) });
      this.courseForm.get('userRoles').setValue(this.userRoles);
      this.loadedCourse = true;
    });
  }

  ngOnInit() {
    this.getCourse();
    this.supporterService.getSupporters().subscribe(
      (data:any) => {
        this.supporters=data;
      }
    );
    this._animalType.getPaginatedAnimalTypes(1,99999).subscribe(
      (data:any)=>{
        this.animalTypes=data.data;
      }
    );
    this.tutorService.getTutors().subscribe(
      (data:any) => {
        this.tutors=data;
      }
    );
    this._cat.getCategories().subscribe(
      res=>{
        this.categories=res;
      }
    );
    this._tag.getPaginatedTags(1,99999999,'').subscribe(
      res=>{
        this.tags=res.data;
      }
    );
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'tag',
      enableCheckAll: false,
      searchPlaceholderText: 'Filter tags',
      itemsShowLimit: 99,
      allowSearchFilter: true
    };

  }

  public addTags()
  {
    let newTags=this.courseForm.get('addTags').value;
    if(newTags.length)
    {
      if (confirm('Confirm you want to add: "'+newTags+'" and assign them to this Video.')) {
        newTags=newTags.split(',');
        newTags.forEach(newTag=>{
          newTag=newTag.trim();
          this._tag.createNewTag(newTag).subscribe(
            res=>{
              newTag={
                id: res.id,
                tag: res.tag,
                created_at: res.created_at,
                updated_at: res.updated_at
              };
              this.courseTags.push(newTag);
              this.refreshSelect();
            }
          );
        });
      }
    }
    else
    {
      alert('Add text to this Add Tags field to continue');
    }
  }

  private refreshSelect()
  {
    this._tag.getPaginatedTags(1,99999999,'').subscribe(
      res=>{
        this.tags=res.data;
        this.courseForm.get('tags').setValue(this.courseTags);
      }
    );
  }
}
